import type {
	CreateReminderRequestDTO,
	UpdateReminderRequestDTO,
} from "web_myplann/Infrastructure/Api/Api";
import type {
	ReminderCreateFormModel,
	ReminderFormModel,
} from "web_myplann/Reminders/Forms/reminderFormSchema";
import { formatApiDate } from "web_myplann/Shared/Utils/apiDate";

export const mapReminderFormToCreateRequest = (
	model: ReminderCreateFormModel,
): CreateReminderRequestDTO => ({
	typeKey: model.typeKey,
	date: formatApiDate(model.date),
	recurrence: model.recurrence,
	...(model.name ? { title: model.name } : {}),
});

export const mapReminderFormToUpdateRequest = (
	model: ReminderFormModel,
): UpdateReminderRequestDTO => ({
	typeKey: model.typeKey,
	title: model.name,
	date: formatApiDate(model.date),
	recurrence: model.recurrence,
});
